import { RootState } from "../reducers";
import { FeatureDcExtended } from "../selectFeatures/types";
import { FeatureDataSource, PreviousFeatureReference } from "./types";
import { LayerInfo } from "../../interfaces/resourceInfo";
import { SelectedFilters } from "../../modules/FeatureCard/types";

export const getFeatureToShow = ({ showFeature }: RootState): FeatureDcExtended => {
  return showFeature && showFeature.feature;
};

export const getLayerToShow = ({ showFeature }: RootState): string => {
  return showFeature && showFeature.layerName;
};

export const getSourceAttributeName = ({ showFeature }: RootState): string => {
  return showFeature && showFeature.sourceAttributeName;
};

export const getSourceLayerInfo = ({ showFeature }: RootState): LayerInfo => {
  return showFeature && showFeature.sourceLayerInfo;
};

export const getReferenceLayerInfos = ({ showFeature }: RootState): LayerInfo[] => {
  return showFeature && showFeature.referenceLayerInfos;
};

export const getSearchString = ({ showFeature }: RootState): string => {
  return showFeature && showFeature.searchString;
};

export const getFeaturePage = ({ showFeature }: RootState): number => {
  return showFeature && showFeature.page;
};

export const getFeatureDataSources = ({ showFeature }: RootState): FeatureDataSource[] => {
  return showFeature && showFeature.dataSources;
};

export const getFeatureDataSourceFilters = ({ showFeature }: RootState): SelectedFilters => {
  return showFeature && showFeature.dataSourceFilters;
};

export const getFeatureDataSourcesAreLoading = ({ showFeature }: RootState): boolean => {
  return showFeature && showFeature.dataSourcesAreLoading;
};

export const getPreviousFeatureReference = ({ showFeature }: RootState): PreviousFeatureReference => {
  return showFeature && showFeature.previousFeatureReference;
};

export const getSelectedTabId = ({ showFeature }: RootState): string => {
  return showFeature && showFeature.selectedTabId;
};
